import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import {
  INVESTOR_BUSINESS_REPORT_OPTIONS,
  type InvestorBusinessReportKey,
} from '@/constants/investorBusinessReports';

type Props = {
  idPrefix: string;
  selected: InvestorBusinessReportKey[];
  onChange: (keys: InvestorBusinessReportKey[]) => void;
};

export default function InvestorReportAccessPicker({ idPrefix, selected, onChange }: Props) {
  const toggle = (key: InvestorBusinessReportKey, checked: boolean) => {
    if (checked) {
      onChange([...new Set([...selected, key])]);
      return;
    }
    onChange(selected.filter((k) => k !== key));
  };

  return (
    <div className="space-y-3 rounded-md border border-indigo-200 bg-indigo-50/50 p-4">
      <div>
        <h3 className="text-sm font-semibold text-gray-900">Business report access</h3>
        <p className="text-xs text-muted-foreground mt-1">
          Choose which Business Reports this investor can view. At least one report is required.
        </p>
      </div>
      <div className="grid gap-2 sm:grid-cols-2 max-h-[280px] overflow-y-auto pr-1">
        {INVESTOR_BUSINESS_REPORT_OPTIONS.map(({ key, label }) => {
          const inputId = `${idPrefix}-investor-report-${key}`;
          const checked = selected.includes(key);
          return (
            <div key={key} className="flex items-start gap-2 rounded-md border bg-white px-3 py-2">
              <Checkbox
                id={inputId}
                checked={checked}
                onCheckedChange={(v) => toggle(key, !!v)}
                className="mt-0.5"
              />
              <Label htmlFor={inputId} className="text-xs font-medium leading-snug cursor-pointer">
                {label}
              </Label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
